import Dinero from 'dinero.js';

const currencies = [
  {
    name: 'MXN',
    keys: ['Mexico', 'MX', 'MXN'],
    cents: true,
    format: '0,0.00',
    factor: 1,
  },
  {
    name: 'CLP',
    keys: ['Chile', 'CL', 'CLP'],
    cents: false,
    format: '0,0',
    factor: 100,
    numberRegex: /^-?(0|[1-9][0-9]*)$/,
  },
  {
    name: 'BRL',
    keys: ['Brazil', 'BR', 'BRL'],
    cents: true,
    format: '0,0.00',
    factor: 1,
  },
];

const defaultNumberRegex = /^-?(0|[1-9][0-9]*)(\.[0-9]*)?$/;

const money = {
  toDisplay: (amount, currency = 'MXN', showCurrency = true) => {
    let currentAmount = amount;
    if (!Number.isInteger(amount)) { currentAmount = 0; }
    const curr = money.mapCurrency(currency);
    const format = (showCurrency) ? `$${curr.format}` : curr.format;
    currentAmount *= curr.factor;
    const currAmount = Dinero({ amount: currentAmount, currency: curr.name });
    return currAmount.toFormat(format);
  },

  toTransact: (amount, currency = 'MXN') => {
    if (!Number.isInteger(amount)) { return 0; }
    const curr = money.mapCurrency(currency);
    const currAmount = Dinero({ amount, currency: curr.name, precision: 2 });
    return currAmount.getAmount();
  },

  mapCurrency: (curr) => {
    const currency = currencies.find((item) => item.keys.includes(curr));
    return currency;
  },

  getNumberRegex: (currency) => {
    const mappedCurrency = money.mapCurrency(currency);
    const regex = ((mappedCurrency && mappedCurrency.numberRegex) || defaultNumberRegex);
    return regex;
  },

  toInt: (amount, currency, applyFactor = true) => {
    if (Number.isInteger(amount)) { return amount; }
    const curr = money.mapCurrency(currency);
    if (!amount) { return 0; }
    const cents = (curr.cents) ? 100 : 1;
    return Math.round(((applyFactor) ? curr.factor : 1) * cents * parseFloat(amount.replace(/[$,]/g, '')));
  },
};

export default money;
